/** CRM quotation Hardware Details table: markup + Jodit-safe +/- row controls (no inline onclick). */

export const buildCrmHardwareDetailsSectionHtml = (cellStyle) => {
    const hwInputStop =
        'onkeydown="event.stopPropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();"';
    const btnStyle =
        "padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;";
    return (
        `<div style="margin: 12px 0; display: flex; justify-content: center;">` +
        `<div style="width: 100%; max-width: 520px;">` +
        `<p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Hardware Details</p>` +
        `<table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;">` +
        `<thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Part name</th><th style="${cellStyle} text-align: right;">Part qty</th></tr></thead>` +
        `<tbody><tr style="background-color: #fff;"><td style="${cellStyle}"><input type="text" style="width: 100%; border: none; outline: none; text-align: left; font-size: 12px;" name="hardwarePartName_0" value="" ${hwInputStop} oninput="this.setAttribute('value', this.value);" /></td>` +
        `<td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="hardwarePartQty_0" value="" ${hwInputStop} oninput="this.value=(this.value||'').toString().replace(/[^0-9]/g,''); this.setAttribute('value', this.value);" /></td></tr></tbody></table>` +
        `<div data-psk-hw-controls="1" contenteditable="false" style="display:flex; justify-content:flex-end; gap:8px; margin-top:8px;"><button type="button" data-psk-hw-add="1" style="${btnStyle}">+</button><button type="button" data-psk-hw-remove="1" style="${btnStyle}">-</button></div></div></div>`
    );
};

/** Resolve jodit-react ref / Jodit instance to the contenteditable root element. */
export const resolveCrmQuotationEditorRootElement = (refOrEditor) => {
    if (!refOrEditor) return null;
    let node = refOrEditor;
    for (let i = 0; i < 3; i += 1) {
        if (node?.nodeType === 1 && typeof node.contains === "function") {
            return node;
        }
        const next = node?.editor;
        if (!next || next === node) break;
        node = next;
    }
    return null;
};

/** True when focus is on a Finance Summary / Hardware Details nested input inside the editor. */
export const isFocusedCrmQuotationEditableTableInput = (
    root,
    isFinanceOrHardwareEditableInputName
) => {
    if (typeof isFinanceOrHardwareEditableInputName !== "function") {
        return false;
    }
    try {
        const el = resolveCrmQuotationEditorRootElement(root);
        if (!el) return false;
        const doc =
            el.ownerDocument ||
            (typeof document !== "undefined" ? document : null);
        if (!doc) return false;
        const active = doc.activeElement;
        if (!active || active.tagName !== "INPUT" || !el.contains(active)) {
            return false;
        }
        return isFinanceOrHardwareEditableInputName(
            active.getAttribute("name") || ""
        );
    } catch {
        return false;
    }
};

export const sanitizeLegacyHardwareControlButtons = (root) => {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('input[name^="hardwarePartName_"]').forEach((inp) => {
        const table = inp.closest?.("table");
        if (!table) return;
        const controls = table.nextElementSibling;
        if (!controls || controls.tagName !== "DIV") return;
        controls.setAttribute("data-psk-hw-controls", "1");
        controls.setAttribute("contenteditable", "false");
        controls.querySelectorAll("button").forEach((btn) => {
            const label = String(btn.textContent || "").trim();
            if (label === "+") {
                btn.removeAttribute("onclick");
                btn.setAttribute("data-psk-hw-add", "1");
            } else if (label === "-") {
                btn.removeAttribute("onclick");
                btn.setAttribute("data-psk-hw-remove", "1");
            }
        });
    });
};

export const attachCrmHardwareTableEditorHandlers = ({
    jodit,
    root,
    setContent,
    isFinanceOrHardwareEditableInputName,
}) => {
    if (!root || !jodit || typeof isFinanceOrHardwareEditableInputName !== "function") {
        return;
    }

    sanitizeLegacyHardwareControlButtons(root);

    const focusNestedInput = (inp) => {
        if (!inp || inp.tagName !== "INPUT") return;
        // Do NOT touch jodit.selection here — its getters can throw
        // "Cannot read properties of undefined (reading 'document')" when focus is in a nested input.
        setTimeout(() => {
            try {
                inp.focus();
                const len = String(inp.value || "").length;
                inp.setSelectionRange(len, len);
            } catch {
                /* ignore */
            }
        }, 0);
    };

    const syncEditorHtmlFromDom = () => {
        const html = root.innerHTML;
        if (typeof setContent === "function") {
            setContent(html);
        }
        try {
            if (jodit?.value !== undefined) {
                jodit.value = html;
            }
        } catch {
            /* ignore */
        }
    };

    const getHardwareDetailsTable = (fromBtn) => {
        if (!fromBtn) return null;
        const controls = fromBtn.closest?.('[data-psk-hw-controls="1"]');
        let table = controls?.previousElementSibling;
        if (!table || table.tagName !== "TABLE") {
            table = fromBtn.parentElement?.previousElementSibling;
        }
        if (!table || table.tagName !== "TABLE") return null;
        if (!table.querySelector?.('input[name^="hardwarePartName_"]')) {
            return null;
        }
        const tbody = table.querySelector("tbody");
        if (!tbody) return null;
        return { table, tbody };
    };

    const buildHardwareRowHtml = (cellStyle, uid) => {
        const inputStop =
            'onkeydown="event.stopPropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();"';
        return (
            `<td style="${cellStyle}"><input type="text" style="width: 100%; border: none; outline: none; text-align: left; font-size: 12px;" name="hardwarePartName_${uid}" value="" ${inputStop} oninput="this.setAttribute('value', this.value);" /></td>` +
            `<td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="hardwarePartQty_${uid}" value="" ${inputStop} oninput="this.value=(this.value||'').toString().replace(/[^0-9]/g,''); this.setAttribute('value', this.value);" /></td>`
        );
    };

    const attachEditableInputKeyStop = (inp) => {
        if (!inp || inp.tagName !== "INPUT") return;
        const inputName = inp.getAttribute("name") || "";
        if (!isFinanceOrHardwareEditableInputName(inputName)) return;
        if (inp.dataset.pskFinancePriceKeyStop) return;
        inp.dataset.pskFinancePriceKeyStop = "1";
        // Stop keys from bubbling into Jodit hotkeys (keeps Backspace/typing in the input).
        const stopJoditKeys = (e) => {
            e.stopPropagation();
        };
        inp.addEventListener("keydown", stopJoditKeys, false);
        if (!inp.getAttribute("onkeydown")) {
            inp.setAttribute("onkeydown", "event.stopPropagation();");
        }
        if (!inp.getAttribute("onmousedown")) {
            inp.setAttribute("onmousedown", "event.stopPropagation();");
        }
    };

    const isNestedFinanceOrHardwareInput = (t) => {
        if (!t || t.tagName !== "INPUT") return false;
        return isFinanceOrHardwareEditableInputName(t.getAttribute("name") || "");
    };

    // Capture on the editor's owner document (iframe-safe) so Jodit root listeners never see the keys.
    const ownerDoc =
        (root && root.ownerDocument) ||
        (typeof document !== "undefined" ? document : null);
    const stopJoditCaptureForNestedInputs = (e) => {
        try {
            if (!isNestedFinanceOrHardwareInput(e.target)) return;
            if (!root || typeof root.contains !== "function" || !root.contains(e.target)) {
                return;
            }
            e.stopPropagation();
        } catch {
            /* ignore */
        }
    };
    if (ownerDoc && typeof ownerDoc.addEventListener === "function") {
        ownerDoc.addEventListener("keydown", stopJoditCaptureForNestedInputs, true);
    }

    const stopJoditFromStealingInnerInputs = (e) => {
        const t = e.target;
        if (!t || typeof t.getAttribute !== "function") return;

        if (t.closest?.('[data-psk-hw-controls="1"]')) {
            return;
        }

        const name = t.getAttribute("name") || "";
        if (isFinanceOrHardwareEditableInputName(name)) {
            e.stopPropagation();
            if (e.type === "mousedown" || e.type === "click") {
                focusNestedInput(t);
            }
            return;
        }

        if (e.type === "mousedown" || e.type === "click") {
            const td = t.closest?.("td");
            if (!td) return;
            const inp =
                t.matches?.("input")
                    ? t
                    : td.querySelector?.('input[name^="servicePrice_"]') ||
                      td.querySelector?.('input[name^="hardwarePartName_"]') ||
                      td.querySelector?.('input[name^="hardwarePartQty_"]');
            if (inp) {
                e.stopPropagation();
                focusNestedInput(inp);
            }
        }
    };

    const onNestedTableInputFocusIn = (e) => {
        const t = e.target;
        if (!t || t.tagName !== "INPUT") return;
        if (!isFinanceOrHardwareEditableInputName(t.getAttribute("name") || "")) {
            return;
        }
        // Intentionally do not call jodit.selection — that path reads .document and can crash.
    };

    const onHardwareTableControlClick = (e) => {
        let addBtn = e.target?.closest?.('[data-psk-hw-add="1"]');
        let removeBtn = e.target?.closest?.('[data-psk-hw-remove="1"]');
        if (!addBtn && !removeBtn) {
            const btn = e.target?.closest?.("button");
            if (!btn || !root.contains(btn) || btn.closest?.(".jodit-toolbar")) {
                return;
            }
            const label = String(btn.textContent || "").trim();
            const ctxProbe = getHardwareDetailsTable(btn);
            if (!ctxProbe) return;
            if (label === "+") addBtn = btn;
            else if (label === "-") removeBtn = btn;
            else return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();

        const ctx = getHardwareDetailsTable(addBtn || removeBtn);
        if (!ctx) return;
        const { tbody } = ctx;

        if (addBtn) {
            const sampleTd = tbody.querySelector("td");
            const cellStyle =
                sampleTd?.getAttribute("style") ||
                "border: 1px solid #000; padding: 4px;";
            const uid = `${Date.now()}${Math.floor(Math.random() * 1000)}`;
            const tr = document.createElement("tr");
            tr.style.backgroundColor = "#fff";
            tr.innerHTML = buildHardwareRowHtml(cellStyle, uid);
            tbody.appendChild(tr);
            tr.querySelectorAll("input").forEach((inp) => {
                attachEditableInputKeyStop(inp);
            });
            const nameInput = tr.querySelector('input[name^="hardwarePartName_"]');
            focusNestedInput(nameInput);
        }

        if (removeBtn) {
            const rows = tbody.querySelectorAll("tr");
            if (rows.length <= 1) return;
            tbody.removeChild(rows[rows.length - 1]);
        }

        syncEditorHtmlFromDom();
    };

    root.addEventListener("mousedown", stopJoditFromStealingInnerInputs, true);
    root.addEventListener("click", stopJoditFromStealingInnerInputs, true);
    root.addEventListener("focusin", onNestedTableInputFocusIn, true);
    root.addEventListener("click", onHardwareTableControlClick, true);

    root
        .querySelectorAll(
            'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
        )
        .forEach(attachEditableInputKeyStop);

    const priceInputObserver = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
            m.addedNodes.forEach((node) => {
                if (!node || node.nodeType !== 1) return;
                const el = node;
                if (
                    el.matches?.(
                        'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
                    )
                ) {
                    attachEditableInputKeyStop(el);
                }
                el
                    .querySelectorAll?.(
                        'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
                    )
                    .forEach(attachEditableInputKeyStop);
                sanitizeLegacyHardwareControlButtons(el);
            });
        });
    });
    priceInputObserver.observe(root, { childList: true, subtree: true });

    const cleanup = () => {
        root.removeEventListener("mousedown", stopJoditFromStealingInnerInputs, true);
        root.removeEventListener("click", stopJoditFromStealingInnerInputs, true);
        root.removeEventListener("focusin", onNestedTableInputFocusIn, true);
        root.removeEventListener("click", onHardwareTableControlClick, true);
        if (ownerDoc && typeof ownerDoc.removeEventListener === "function") {
            ownerDoc.removeEventListener("keydown", stopJoditCaptureForNestedInputs, true);
        }
        priceInputObserver.disconnect();
    };

    if (jodit.e?.one) {
        jodit.e.one("beforeDestruct", cleanup);
    }

    return cleanup;
};
